import { clone, isPlainObject, lowerCase, mix } from '@antv/util';
import { View } from '../chart';
import { LooseObject } from '../interface';
import GrammarInteraction, { InteractionSteps } from './grammar-interaction';
import { InteractionConstructor } from './interaction';

const Interactions: LooseObject = {};

/**
 * æ ¹æ®äº¤äºè¡ä¸ºåå­è·åå¯¹åºçäº¤äºç±»
 * @param name äº¤äºåå­
 * @returns äº¤äºç±»
 */
export function getInteraction(name: string): InteractionSteps | InteractionConstructor {
  return Interactions[lowerCase(name)];
}

/**
 * æ³¨åäº¤äºè¡ä¸º
 * @param name äº¤äºè¡ä¸ºåå­
 * @param interaction äº¤äºç±»
 */
export function registerInteraction(name: string, interaction: InteractionSteps | InteractionConstructor) {
  Interactions[lowerCase(name)] = interaction;
}

/**
 * åå»ºäº¤äºå®ä¾
 * @param name äº¤äºå
 * @param view äº¤äºåºç¨ç View å®ä¾
 * @param cfg äº¤äºè¡ä¸ºéç½®
 */
export function createInteraction(name: string, view: View, cfg?: LooseObject) {
  const interaciton = getInteraction(name);
  if (!interaciton) {
    return null;
  }
  if (isPlainObject(interaciton)) {
    // å¦æä¸ clone åä¼å¤ä¸ª interaction å®ä¾å±äº« step çå®ä¹
    const steps = mix(clone(interaciton), cfg) as InteractionSteps;
    return new GrammarInteraction(view, steps);
  } else {
    const cls = interaciton as InteractionConstructor;
    return new cls(view, cfg);
  }
}

export { default as Interaction } from './interaction';
export { Action, registerAction, getActionClass } from './action';
